/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Gavel = [
  ["path", { d: "m14 13-8.381 8.38a1 1 0 0 1-3.001-3l8.384-8.381" }],
  ["path", { d: "m16 16 6-6" }],
  ["path", { d: "m21.5 10.5-8-8" }],
  ["path", { d: "m8 8 6-6" }],
  ["path", { d: "m8.5 7.5 8 8" }]
];

export { Gavel as default };
//# sourceMappingURL=gavel.js.map
